// extracted by mini-css-extract-plugin
export default {"root":"Admin_root__YS52y"};